import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  SimpleGrid,
  Text,
  useColorModeValue
} from "@chakra-ui/react";
import useCategorias from "../categorias/hooks/useCategorias";
import SubCategoryTable from "./components/Table";
import useSubCategory from "./hooks/useSubCategory";

const SubCategoriesScreen = () => {
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");

  const {
    lista,
    add,
    edit,
    loading,
    show,
    showModal,
    accountSelected,
    nomeRef,
    error,
    save,
    showDelete,
    showDeleteModal,
    cancelRef,
    closeDelete,
    deletar,
    deptoRef,
    
  } = useSubCategory();

  const { accountTypeList } = useCategorias();
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
        <SubCategoryTable
          add={add}
          edit={edit}
          list={lista}
          deletar={showDeleteModal}
          showDelete={showDelete}
          cancelRef={cancelRef}
          closeDelete={closeDelete}
          remove={deletar}
        />

        <Modal
          onClose={() => {
            showModal(false);
          }}
          size={"2xl"}
          isOpen={show}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
              {accountSelected !== null
                ? "Editar Subcategoria Financeira"
                : "Nova Subcategoria Financeira"}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <FormControl isInvalid={error}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  color={textColor}
                  mb="8px"
                >
                  Categoria Financeira<Text color={brandStars}>*</Text>
                </FormLabel>
                <Select
                  ref={deptoRef}
                  defaultValue={accountSelected?.categoriaLancamentoId}
                  isRequired={true}
                  variant="auth"
                  fontSize="sm"
                  ms={{ base: "0px", md: "0px" }}
                  placeholder="Preencha a Categoria Financeira"
                  onChange={(e) => (deptoRef.current = e.target.value)}
                  mb="24px"
                  fontWeight="500"
                  isInvalid={error}
                  size="lg"
                >
                  {accountTypeList?.map((item) => (
                    <option
                      value={item.id}
                      key={item.id}
                      selected={item.id === accountSelected?.categoriaLancamentoId}
                    >
                      {item.nome}
                    </option>
                  ))}
                </Select>
                {error && (
                  <FormErrorMessage>
                    Preencha Corretamente o Campo.
                  </FormErrorMessage>
                )}
              </FormControl>
              <FormControl isInvalid={error}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  color={textColor}
                  mb="8px"
                >
                  Nome<Text color={brandStars}>*</Text>
                </FormLabel>
                <Input
                  ref={nomeRef}
                  defaultValue={accountSelected?.nome}
                  isRequired={true}
                  variant="auth"
                  fontSize="sm"
                  ms={{ base: "0px", md: "0px" }}
                  type="text"
                  placeholder="Preencha o nome do centro de custo"
                  onChange={(e) => (nomeRef.current = e.target.value)}
                  mb="24px"
                  fontWeight="500"
                  isInvalid={error}
                  size="lg"
                />
                {error && (
                  <FormErrorMessage>
                    Preencha Corretamente o Campo.
                  </FormErrorMessage>
                )}
              </FormControl>
            </ModalBody>
            <ModalFooter>
              <Button
                onClick={() => {
                  showModal(false);
                }}
                variant="outline"
                marginRight={4}
              >
                Fechar
              </Button>
              <Button
                onClick={() => {
                  save();
                }}
                colorScheme="brand"
                isLoading={loading}
              >
                Salvar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </SimpleGrid>
    </Box>
  );
};
export default SubCategoriesScreen;
